import './About.scss'
import { motion } from 'framer-motion'
import {useState,useEffect} from 'react'
import React from 'react'
import { AppWrap, MotionWrap } from '../../wrapper'
// import {images} from '../../constants'

import { urlFor,client } from '../../client'

// using dynamic abouts coming from the backend sanity
// const abouts = [
//   {title: 'Web Developer', description: 'I am good developer', imgUrl: images.about01},
//   {title: 'Web Designer', description: 'I am good Designer', imgUrl: images.about02},
//   {title: 'UI/UX', description: 'I am good developer', imgUrl: images.about03},
//   {title: 'Web Animation', description: 'I am a Animator', imgUrl: images.about04}
// ]

const About = () => {
  const [abouts, setAbouts] = useState([])

  useEffect(() => {
    const query = '*[_type == "abouts"]'
    client.fetch(query)
      .then((data) => setAbouts(data))
  }, [])
  
  return (
    <>
      <h2 className='head-text'>I have <span>interest</span> in the following fields
      </h2>

      <div className="app__profiles">
        {abouts.map( (about,index) => (
          <motion.div
            whileInView={{opacity: 1}}
            whileHover={{scale: 1.1}}
            transition={{duration: 0.5, type: 'tween'}}
            key={about.title + index}
            className='app__profiles-info'
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className='bold-text' style={{marginTop: 20}}>{about.title} </h2>
            <p className="p-text" style={{marginTop: 10}}>{about.description} </p>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(About,'app__about'),
  'about',
  'app__whitebg')